import { useMemo } from 'react';
import { EntityAboutCard } from '@backstage/plugin-catalog';
import { EntityProvider, useEntity } from '@backstage/plugin-catalog-react';
import { useIsExternalUser } from '../externalUser';

const TECHDOCS_REF_ANNOTATION = 'backstage.io/techdocs-ref';
const EXTERNAL_DOCS_ANNOTATION = 'savr.com/external-docs';

/**
 * The stock About card offers a "View TechDocs" link whenever the entity has
 * a techdocs-ref annotation - for external users without docs access that
 * link only leads to a 403 (techdocsExternalGuard). Stripping the annotation
 * from the entity the card sees renders the link in its disabled state
 * instead. Internal users get the unmodified card.
 */
export function SavrAboutCard() {
  const { entity } = useEntity();
  const isExternal = useIsExternalUser();

  const visibleEntity = useMemo(() => {
    const annotations = entity.metadata.annotations ?? {};
    const hideDocs =
      isExternal === true &&
      annotations[TECHDOCS_REF_ANNOTATION] &&
      annotations[EXTERNAL_DOCS_ANNOTATION] !== 'true';
    if (!hideDocs) {
      return entity;
    }
    const { [TECHDOCS_REF_ANNOTATION]: _omitted, ...rest } = annotations;
    return {
      ...entity,
      metadata: { ...entity.metadata, annotations: rest },
    };
  }, [entity, isExternal]);

  if (visibleEntity === entity) {
    return <EntityAboutCard />;
  }
  return (
    <EntityProvider entity={visibleEntity}>
      <EntityAboutCard />
    </EntityProvider>
  );
}
